import {
  DataField,
  Divider,
  Flex,
  Header,
  Space,
  TextLoader,
} from '@procurify/ui'

import { TabPanes } from '@webapp/components/TabPanes'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from '../../messages'

export const VendorDetailLoader = () => {
  const intl = useProcurifyIntl()

  return (
    <div>
      <Space align='stretch'>
        <Space direction='horizontal' align='center'>
          <Header as='h4'>
            <TextLoader height={20} />
          </Header>
        </Space>
        <TabPanes activeKey='1'>
          <TabPanes.Pane
            label={intl.formatMessage(messages.contactInformationTabLabel)}
            key='1'
          >
            <Flex.Row>
              <Flex.Item>
                <DataField label={intl.formatMessage(messages.addressLabel)}>
                  <TextLoader width={200} />
                  <br />
                  <TextLoader width={200} />
                  <br />
                  <TextLoader width={250} />
                </DataField>
              </Flex.Item>
            </Flex.Row>
            <Flex.Row>
              <Flex.Item width={1 / 3}>
                <DataField
                  label={intl.formatMessage(messages.paymentTermsLabel)}
                >
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 3}>
                <DataField
                  label={intl.formatMessage(messages.shippingViaLabel)}
                >
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 3}>
                <DataField
                  label={intl.formatMessage(messages.shippingTermsLabel)}
                >
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
            </Flex.Row>
            <Divider />
            <Flex.Row>
              <Flex.Item width={1 / 2}>
                <DataField
                  label={intl.formatMessage(messages.contactRepNameLabel)}
                >
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 2}>
                <DataField label={intl.formatMessage(messages.vendorIdLabel)}>
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 2}>
                <DataField label={intl.formatMessage(messages.phoneLabel)}>
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 2}>
                <DataField label={intl.formatMessage(messages.phoneTwoLabel)}>
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 2}>
                <DataField label={intl.formatMessage(messages.faxLabel)}>
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1 / 2}>
                <DataField label={intl.formatMessage(messages.websiteLabel)}>
                  <TextLoader width={150} />
                </DataField>
              </Flex.Item>

              <Flex.Item width={1}>
                <DataField label={intl.formatMessage(messages.emailsLabel)}>
                  <TextLoader width={300} />
                </DataField>
              </Flex.Item>
              <Flex.Item width={1}>
                <DataField
                  label={intl.formatMessage(messages.vendorCommentLabel)}
                >
                  <TextLoader width={300} />
                </DataField>
              </Flex.Item>
            </Flex.Row>
          </TabPanes.Pane>
          <TabPanes.Pane
            label={intl.formatMessage(messages.settingsTabLabel)}
            key='2'
          />
          <TabPanes.Pane
            label={intl.formatMessage(messages.paymentMethodsHeader)}
            key='3'
          />
        </TabPanes>
      </Space>
    </div>
  )
}

VendorDetailLoader.displayName = 'VendorDetailLoader'
